'use client';

import React from 'react';
import { Button, Layout, Typography } from 'antd';
import styles from './Contact.module.scss';
import { ScrollReveal } from '@/shared/ui/ScrollReveal/ScrollReveal';
import { useLocale, useTranslations } from 'next-intl';
import Link from 'next/link';

const { Content } = Layout;

interface ContactProps {
  storeUrl: string;
  btnText?: string;
  customUrl?: string;
  target?: string;
}

export function Contact({ btnText = 'install', storeUrl, customUrl, target }: ContactProps) {
  const t = useTranslations('contact');
  const locale = useLocale();
  return (
    <Content className={styles.root} id="contact">
      <ScrollReveal variant="fadeUp">
        <Typography className={styles.ctaTitle}>{t('title')}</Typography>
      </ScrollReveal>
      <ScrollReveal variant="fadeUp">
        <Typography className={styles.ctaSubtitle}>{t('subtitle')}</Typography>
      </ScrollReveal>
      <ScrollReveal variant="fadeUp">
        <Link
          href={customUrl ? customUrl : `/${locale}${storeUrl}`}
          target={target ? target : '_blank'}
          rel="noopener noreferrer"
        >
          <Button
            className={styles.btnCtaPrimary}
          // href="#extensions"
          >
            {t(btnText)}
          </Button>
        </Link>
      </ScrollReveal>
    </Content>
  );
}
